import React from "react";
import { LoginGigyaInterface } from "../shared/interfaces/LoginGigyaInterface";

interface GlobalContextInterface {
  fontSize: { get: number; set: (size: number) => void };
  superFooter: { get: boolean; set: (value: boolean) => void };
  genreSelected: { get: string; set: (value: string) => void };
  gigyaUid: { get: string; set: (value: string) => void };
  gigyaContext: LoginGigyaInterface;
}

const defaultContext: GlobalContextInterface = {
  fontSize: { get: 16, set: () => {} },
  superFooter: { get: false, set: () => {} },
  genreSelected: { get: '', set: () => {} },
  gigyaUid: { get: '', set: () => {} },
  gigyaContext: {
    login: () => null,
    loginComfamaId: () => null,
    logout: () => null,
    updateProfile: () => null,
    register: () => null,
    showScreen: () => null,
    updateProfilePhoto: () => null,
    gigyaAccount: undefined,
    isLoadingGigya: false,
  },
};

const GlobalContext = React.createContext<GlobalContextInterface>(defaultContext);

export default GlobalContext;
